import * as React from 'react';
export var Context = React.createContext({
    errorMessages: new Map(),
    fallback: function (errorMessage) { return <>{errorMessage}</>; },
    handler: function () { return 'Error'; },
    setErrorMessages: function () { },
});
Context.displayName = 'ErrorHandler.Context';
export var ErrorConsumer = function (_a) {
    var children = _a.children;
    var errorMessage = useErrorHandler().errorMessage;
    return <>{errorMessage !== null ? children(errorMessage) : null}</>;
};
export var useErrorHandler = function () {
    var _a;
    var id = React.useState(function () { return String(Math.random()); })[0];
    var _b = React.useContext(Context), errorMessages = _b.errorMessages, fallback = _b.fallback, handler = _b.handler, setErrorMessages = _b.setErrorMessages;
    var updateErrorMessage = React.useCallback(function (errorMessage) {
        // tslint:disable-next-line: no-null-undefined-union
        setErrorMessages(function (errorMessages) {
            var newErrorMessages = new Map(errorMessages);
            if (errorMessage !== null) {
                newErrorMessages.set(id, errorMessage);
            }
            else {
                newErrorMessages.delete(id);
            }
            return newErrorMessages;
        });
    }, []);
    React.useEffect(function () { return function () {
        updateErrorMessage(null);
    }; }, []);
    var errorMessage = (_a = Array.from(errorMessages.values())[0]) !== null && _a !== void 0 ? _a : null;
    return {
        error: errorMessage !== null ? function () { return <>{fallback(errorMessage)}</>; } : function () { return null; },
        errorMessage: errorMessage,
        onError: function (error) {
            updateErrorMessage(error !== null ? handler(error) : null);
        },
        onUserError: updateErrorMessage,
    };
};
